import SeriesSubPage from "./components/SeriesSubPage";
import { Skeleton } from "@/components/ui/skeleton";

export const BtsTileSkeleton = () => (
  <div className="flex flex-col gap-2">
    <Skeleton className="aspect-9/16 rounded-lg" />
    <Skeleton className="h-4 w-3/4" />
  </div>
);

/** The View all page's grid, also what it shows while its own query runs. */
export const BtsGridSkeleton = () => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-5 sm:gap-4">
    {Array.from({ length: 5 }, (_, i) => (
      <BtsTileSkeleton key={i} />
    ))}
  </div>
);

/** View all Behind the Scenes while the series loads: the page's own shape. */
const SeriesBtsSkeleton = () => (
  <SeriesSubPage.Skeleton testId="series-bts-skeleton" titleWidth="w-48">
    <BtsGridSkeleton />
  </SeriesSubPage.Skeleton>
);

export default SeriesBtsSkeleton;
